$(document).ready(function () {
    const customer = document.querySelector('.customer-page')
    const kariera = document.querySelector('.in-jak-to-u-nas-chodi')
    const kariera1 = document.querySelector('.in-otevrene-pracovni-pozice')

    if (customer) {
        const clientBox = document.querySelectorAll('.client-center-box ul li a')

        if (clientBox) {
            clientBox.forEach((boxItem) => {
                const boxItemText = boxItem.textContent.trim()

                const hideItem = (targetText) => {
                    if (boxItemText === targetText) {
                        boxItem.parentElement.classList.add('hide')

                        boxItem.addEventListener('click', function (event) {
                            event.preventDefault()
                        })
                    }
                }
                hideItem('Moje slevy')
                hideItem('Moje doklady')
                hideItem('Moje hodnocení u produktů')
                hideItem('Moje diskuze u produktů')
            })

            document.querySelector('.client-center-box').classList.add('ready')
        }
    }

    if (kariera || kariera1) {
        const text = document.querySelector('.text')

        if (text) {
            text.insertAdjacentHTML(
                'beforeend',
                `<a href = "https://515494.myshoptet.com/kariera/" class = "btn btn-primary back-to-kariera">Zpět na kariéru</a>`
            )
        }
    }
});

$('html').on('click', '.ifameLink', function(){
    var videoLink = $(this).data('link');
    if (videoLink.indexOf('?') === -1) {
        videoLink += '?autoplay=1&controls=1&rel=0';
    } else {
        videoLink += '&autoplay=1&controls=1&rel=0';
    }
    $.colorbox({
        href: videoLink,
        iframe: true,
        innerWidth: 440,
        innerHeight: 560,
        maxWidth: '90%',
        maxHeight: '90%',
    });
});